import "./css/main.css";
import "liquid-ajax-cart";
import NiceSelect from "nice-select2/dist/js/nice-select2";

// Components
import "./js/components/accordion";
import "./js/components/swiper";
import "./js/components/dialog";
import "./js/components/drawer";
import "./js/components/modal";
import "./js/components/autocomplete";
import "./js/components/facets";
import "./js/components/ajaxinate";
import "./js/components/search";
import "./js/components/selling-plan";
import "./js/components/quick-order";
import "./js/components/quick-course-search";
import "./js/components/tax-changer";
import "./js/components/course-finder-form";
import "./js/components/wpt-course-finder";

// Snippet
import "./js/snippets/product-card";
import "./js/snippets/localization-form";

// Templates
import "./js/templates/cart";
import "./js/templates/bundles";
import "./js/templates/header";

// Templates
import LoadSections from "./js/sections";

// Global Moonbase variable
const Moonbase = window.Moonbase || {};

Moonbase.closeMapModal = () => {
  const mapModal = document.querySelector(".workplace__modal");
  if (mapModal) {
    mapModal.classList.remove("active");
  }
};
Moonbase.setRecentlyViewedProducts = (productData) => {
  const productList = [];
  let jsonRespArr;
  productList.push(productData);
  const currProductPageTitle = productData.title;
  const productDataString = JSON.stringify(productList);
  const localData = localStorage.getItem("recentlyViewedProducts");
  if (localData === null) {
    localStorage.setItem("recentlyViewedProducts", productDataString);
  } else if (localData) {
    const oldProductData = localStorage.getItem("recentlyViewedProducts");
    const parsedOldProductData = JSON.parse(oldProductData);
    const sameProduct = oldProductData.includes(currProductPageTitle);
    if (sameProduct) {
      const index = parsedOldProductData.findIndex(
        (product) => product.title === currProductPageTitle
      );
      if (index !== -1) {
        parsedOldProductData[index] = productData;
        localStorage.setItem(
          "recentlyViewedProducts",
          JSON.stringify(parsedOldProductData)
        );
      }
    } else {
      jsonRespArr = parsedOldProductData.concat(productList);
      localStorage.setItem(
        "recentlyViewedProducts",
        JSON.stringify(jsonRespArr)
      );
    }
  }
};

// Initialisation code
document.addEventListener("DOMContentLoaded", () => {
  const Moonbase = window.Moonbase || {};
  Moonbase.NiceSelect = NiceSelect;
  console.log("🚀 Shopify Theme by Brave The Skies");

  function setCartCustomerLoggedInAttribute(requestState) {
    const { isLoggedIn } = window.customerStatus || {};
    if (
      typeof isLoggedIn === "boolean" &&
      (requestState.requestType === "add" ||
        requestState.requestType === "update")
    ) {
      if (!requestState.requestBody) {
        requestState.requestBody = {};
      }
      if (!requestState.requestBody.attributes) {
        requestState.requestBody.attributes = {};
      }
      requestState.requestBody.attributes.customer_is_logged_in =
        isLoggedIn.toString();
      console.log(
        "Set cart attribute customer_is_logged_in to",
        isLoggedIn.toString()
      );
    }
  }

  // Liquid Ajax Cart Request Start Listener to set a Cart Attribute
  document.addEventListener("liquid-ajax-cart:request-start", (event) => {
    setCartCustomerLoggedInAttribute(event.detail.requestState);
  });

  setCartCustomerLoggedInAttribute({ requestType: "init", requestBody: {} });

  const niceSelects = document.querySelectorAll(".form-select");
  if (niceSelects.length) {
    niceSelects.forEach((select) => {
      new NiceSelect(select, { searchable: false });
    });
  }

  const mapModalButtons = document.querySelectorAll("[js-open-map-modal]");

  if (mapModalButtons.length > 0) {
    mapModalButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const mapModal = document.querySelector(".workplace__modal");
        if (mapModal) {
          mapModal.classList.add("active");
          mapModal.setAttribute("tabindex", "-1");
          mapModal.focus();
        }
      });
    });
  }

  const closeMapModalButtons = document.querySelectorAll(
    "[js-close-map-modal]"
  );
  if (closeMapModalButtons.length > 0) {
    closeMapModalButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const mapModal = document.querySelector(".workplace__modal");
        if (mapModal) {
          mapModal.classList.remove("active");
        }
      });
    });
  }

  const openProductDescription = document.querySelector(
    "[open-product-description]"
  );
  const productDescriptionAccordion = document.querySelector(
    "accordion-element[data-type='description']"
  );

  if (openProductDescription && productDescriptionAccordion) {
    openProductDescription.addEventListener("click", () => {
      productDescriptionAccordion.toggleAccordion();
      const yOffset = -100;
      const y =
        productDescriptionAccordion.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  }

  // Add a special CSS class when the cart-icon is clicked
  const cartIcon = document.querySelector("#cart-icon");
  if (cartIcon) {
    document.querySelector("#cart-icon").addEventListener("click", function () {
      document.body.classList.toggle(Moonbase.classes.minicartOpen);
    });
  }
  // Listen for the "liquid-ajax-cart:request-end" event which is fired
  // after a Shopify Cart API Ajax request is performed

  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail;
    const previousCart = event.detail.previousCart;
    const currentCart = event.detail.cart;

    const previousItems = previousCart?.items || [];
    const currentItems = currentCart?.items || [];

    const removedItems = previousItems.filter(
      (prevItem) =>
        !currentItems.some((currItem) => currItem.id === prevItem.id)
    );

    let isWPTCourseInCart = false;
    const cartChanged =
      previousItems.length !== currentItems.length ||
      previousItems.some(
        (prevItem, idx) =>
          !currentItems[idx] ||
          prevItem.id !== currentItems[idx].id ||
          prevItem.quantity !== currentItems[idx].quantity
      );

    if (cartChanged) {
      isWPTCourseInCart = currentItems.some(
        (item) => item.product_type === "Workplace Training Course"
      );
    }

    if (isWPTCourseInCart) {
      const now = new Date();
      const future = new Date(now.getTime() + 60 * 60 * 1000); // 1 hour from now
      localStorage.setItem("timeRemaining", future.toISOString());
    }

    if (removedItems.length > 0) {
      removedItems.forEach((item) => {
        const key = `attendeeDetails-${item.id}`;
        localStorage.removeItem(key);
      });
    }

    // If the "add to cart" request is successful
    if (requestState.requestType === "add" && requestState.responseData?.ok) {
      if (body.classList.contains("minicart-enabled")) {
        document.body.classList.add("overlay--active");
      } else {
        let productId = requestState.responseData.body.id;
        const toastItems = document.querySelectorAll(".toast__item");

        if (productId === undefined || productId === null) {
          let productId = requestState.responseData.body.items[0].id;
          document.querySelector(".minicart-section").classList.add("toast");
          document.body.classList.add("toast--active");

          if (window.innerWidth > 1440) {
            let windowWidth = window.innerWidth;
            const containerWidth = 1400;

            const offset = (windowWidth - containerWidth) / 2 + 30;
            document.querySelector(".toast").style.right = `${offset}px`;
          }

          // if data product id doesn't match the product Id add a class
          let productIdString = productId.toString();
          if (toastItems.length > 0) {
            toastItems.forEach((item) => {
              if (item.getAttribute("data-product-id") !== productIdString) {
                item.classList.add("hidden");
              } else {
                item.classList.remove("hidden");
              }
            });
          }

          //wait 5 s then remove all

          setTimeout(() => {
            document.body.classList.remove("toast--active");
          }, 5000);
        } else {
          document.querySelector(".minicart-section").classList.add("toast");
          document.body.classList.add("toast--active");

          // if data product id doesn't match the product Id add a class
          let productIdString = productId.toString();

          if (toastItems.length > 0) {
            toastItems.forEach((item) => {
              if (item.getAttribute("data-product-id") !== productIdString) {
                item.classList.add("hidden");
              } else {
                item.classList.remove("hidden");
              }
            });
          }

          //wait 5 s then remove all..
          setTimeout(() => {
            document.body.classList.remove("toast--active");
          }, 5000);
        }
      }
    }
  });

  window.Moonbase.setRecentlyViewedProducts = (productData) => {
    const productList = [];
    let jsonResp, jsonRespArr, jsonRespArrStr;
    productList.push(productData);
    const currProductPageTitle = productData.title;
    const productDataString = JSON.stringify(productList);
    const localData = localStorage.getItem("recentlyViewedProducts");
    if (localData === null) {
      localStorage.setItem("recentlyViewedProducts", productDataString);
    } else if (localData) {
      const oldProductData = localStorage.getItem("recentlyViewedProducts");
      const parsedOldProductData = JSON.parse(oldProductData);
      const sameProduct = oldProductData.includes(currProductPageTitle);
      if (sameProduct) {
        const index = parsedOldProductData.findIndex(
          (product) => product.title === currProductPageTitle
        );
        if (index !== -1) {
          parsedOldProductData[index] = productData;
          localStorage.setItem(
            "recentlyViewedProducts",
            JSON.stringify(parsedOldProductData)
          );
        }
      } else {
        const { requestState } = event.detail;
        let productId = requestState.responseData.body.id;
        const toastItems = document.querySelectorAll(".toast__item");

        if (productId === undefined || productId === null) {
          let productId = requestState.responseData.body.items[0].id;
          document.querySelector(".minicart-section").classList.add("toast");
          document.body.classList.add("toast--active");

          if (window.innerWidth > 1440) {
            let windowWidth = window.innerWidth;
            const containerWidth = 1400;

            const offset = (windowWidth - containerWidth) / 2 + 30;
            document.querySelector(".toast").style.right = `${offset}px`;
          }

          // if data product id doesn't match the product Id add a class
          let productIdString = productId.toString();
          if (toastItems.length > 0) {
            toastItems.forEach((item) => {
              if (item.getAttribute("data-product-id") !== productIdString) {
                item.classList.add("hidden");
              } else {
                item.classList.remove("hidden");
              }
            });
          }

          //wait 5 s then remove all

          setTimeout(() => {
            document.body.classList.remove("toast--active");
          }, 5000);
        } else {
          document.querySelector(".minicart-section").classList.add("toast");
          document.body.classList.add("toast--active");

          // if data product id doesn't match the product Id add a class
          let productIdString = productId.toString();

          if (toastItems.length > 0) {
            toastItems.forEach((item) => {
              if (item.getAttribute("data-product-id") !== productIdString) {
                item.classList.add("hidden");
              } else {
                item.classList.remove("hidden");
              }
            });
          }

          //wait 5 s then remove all..
          setTimeout(() => {
            document.body.classList.remove("toast--active");
          }, 5000);
        }
      }
    }
  };

  const closeOverlayButtons = document.querySelectorAll(
    "[close-overlay-button]"
  );

  if (closeOverlayButtons.length > 0) {
    closeOverlayButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        document.body.classList.remove(Moonbase.classes.minicartOpen);
      });
    });
  }

  // Add mutation observer to body for change in classes for the overlay--active or bundles-overlay--active or toast-active
  const body = document.querySelector("body");
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        if (body.classList.contains("overlay--active")) {
          const siteOverlay = document.querySelector(".site-overlay");
          siteOverlay.addEventListener("click", (event) => {
            body.classList.remove("overlay--active");
          });
        }

        if (body.classList.contains("toast--active")) {
          const siteOverlay = document.querySelector(".site-overlay");
          siteOverlay.addEventListener("click", (event) => {
            body.classList.remove("toast--active");
          });
        }
      }
    });
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ["class"],
  });

  // Bundles Size Drawer - Open and Close
  const bundleButtons = document.querySelectorAll("[bundles-drawer-open]");
  if (bundleButtons.length > 0) {
    bundleButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const sideDrawerType = button.dataset.type;
        const bundleDrawer = document.querySelector(
          `bundle-side-drawer[data-type="${sideDrawerType}"]`
        );
        if (bundleDrawer) {
          bundleDrawer.classList.remove("closed");
          document.body.classList.add("bundles-overlay--active");
          // Move keyboard focus to the side drawer
          bundleDrawer.setAttribute("tabindex", "-1");
          bundleDrawer.focus();
        }
      });
    });
  }

  window.addEventListener("scroll", function () {
    const form = document.querySelector(".product-main__form");
    const stickyAtc = document.querySelector(".product__sticky-atc");
    if (!form || !stickyAtc) return;

    const formRect = form.getBoundingClientRect();
    if (formRect.bottom < 0) {
      stickyAtc.classList.remove("hidden");
    } else {
      stickyAtc.classList.add("hidden");
    }
  });

  document.documentElement.className =
    document.documentElement.className.replace("no-js", "js");

  /* Initialise a global Moonbase variable
	 that can be accessed on the front end
	 if not already defined. */

  // used to dynamically load template & section js per page.
  // prevents loading js that isn't required
  // Add sections in theme-js.liquid:
  // Moonbase.sections = [
  //      ...
  //     'my-new-section'
  // ]
  LoadSections(Moonbase.sections)
    .then(() => {
      Moonbase.loaded = true;
      const evt = new CustomEvent("moonbase:loaded");
      document.dispatchEvent(evt);
    })
    .catch((e) => console.log("Error loading template files", e));
});
